export default __webpack_public_path__ + "static/ponti-radio-9fca86fdd9418744d5c008914a7b576e.png";